"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = void 0;
const assets_1 = require("./assets");
exports.chains = {
    ethereum: {
        name: 'Ethereum',
        slug: 'ethereum',
        image: assets_1.ethereumImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: true
    },
    gnosis: {
        name: 'Gnosis',
        slug: 'gnosis',
        image: assets_1.gnosisImage,
        nativeTokenSymbol: 'XDAI',
        isLayer1: false
    },
    polygon: {
        name: 'Polygon',
        slug: 'polygon',
        image: assets_1.polygonImage,
        nativeTokenSymbol: 'MATIC',
        isLayer1: false
    },
    arbitrum: {
        name: 'Arbitrum',
        slug: 'arbitrum',
        image: assets_1.arbitrumImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: false
    },
    optimism: {
        name: 'Optimism',
        slug: 'optimism',
        image: assets_1.optimismImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: false
    },
    nova: {
        name: 'Nova',
        slug: 'nova',
        image: assets_1.novaImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: false
    },
    zksync: {
        name: 'zkSync',
        slug: 'zksync',
        image: assets_1.zksyncImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: false
    },
    consensyszk: {
        name: 'ConsenSys zkEVM',
        slug: 'consensyszk',
        image: assets_1.consensyszkImage,
        nativeTokenSymbol: 'ETH',
        isLayer1: false
    }
};
